import BaseModalEventBunpimay from './BaseModalEventBunpimay';
import headerPopupAll from 'assets/images/eventBunpimay/headerPopupFNAll.png'
import headerPopupTop from 'assets/images/eventBunpimay/headerPopupFNTop.png'
import { getRankEventBunpimayQuery } from 'dataLayer/game';
import { getUserQuery } from 'dataLayer/user';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { getData, setData } from 'utils/localStorage';
import imgPrizePhone from 'assets/images/eventBunpimay/samsung.png'
import imgPrizeHeadphone from 'assets/images/eventBunpimay/headphonePrize.png'
import imgPrizeMoney from 'assets/images/eventBunpimay/moneyPrize.png'
import { PATHS } from 'config/routes';
import { Button } from 'react-bootstrap';

function ModalWinnerEventBunpimay() {
	const { t } = useTranslation()
	const navigate = useNavigate()
	const [winnerPopup, setWinnerPopup] = useState(0)
	const [typePopup, setTypePopup] = useState(1)
	const [show, setShow] = useState(false)
	const {
		data: rankBunpimay,
		isLoading: isLoadingRank,
		refetch: refetchRank
	} = useQuery(getRankEventBunpimayQuery(1, 0, 10))
	const { data: user, isLoading: isLoadingUser } = useQuery(getUserQuery())
	const onHide = () => {
		setShow(false);
	}
	useEffect(() => {
		if (user) {
			if (rankBunpimay && rankBunpimay?.ranks) {
				const listTopUser = [
					rankBunpimay?.ranks?.data[0]?.userId,
					rankBunpimay?.ranks?.data[1]?.userId,
					rankBunpimay?.ranks?.data[2]?.userId,
				]

				const indexTopUser = listTopUser.indexOf(user?.id)

				if (indexTopUser !== -1) {
					const checkWatched = getData(
						`watched_pop_up_bunpimay_${indexTopUser + 1}_${user?.id}`,
					)
					if (!checkWatched) {
						setShow(true)
						setWinnerPopup(indexTopUser)
						setData(`watched_pop_up_bunpimay_${indexTopUser + 1}_${user?.id}`, true)
						setTypePopup(1)
					}
				} else {
					const checkWatched = getData('watched_pop_up_bunpimay_4')
					if (!checkWatched) {
						setShow(true)
						setWinnerPopup(3)
						setData('watched_pop_up_bunpimay_4', true)
						setTypePopup(2)
					}
				}
			}
		} else {
			const checkWatched = getData('watched_pop_up_bunpimay_4')
			if (!checkWatched) {
				setShow(true)
				setWinnerPopup(3)
				setData('watched_pop_up_bunpimay_4', true)
				setTypePopup(2)
			}
		}
	}, [rankBunpimay, user])

	const listItem = [
		{
			imgGift: imgPrizePhone,
			description: t('event.bunpimay.result.top_1'),
		},
		{
			imgGift: imgPrizeHeadphone,
			description: t('event.bunpimay.result.top_2'),
		},
		{
			imgGift: imgPrizeMoney,
			description: t('event.bunpimay.result.top_3'),
		},
	]
	const handleNavigate = () => {
		navigate(PATHS.BUNPIMAY_PAGE_HOME, {
			state: {
				rank: 'rank'
			}
		})
		onHide()
	}
	return (<BaseModalEventBunpimay
		srcImgHeader={typePopup === 1 ? headerPopupTop : headerPopupAll}
		show={show}
		onHide={onHide}
		hideDecor={typePopup === 1 ? 'bgr_FN' : null}
	>
		<div className="modal-finish">
			{[0, 1, 2].indexOf(winnerPopup) !== -1 && (
				<span className={`modal-finish-gift prize_${winnerPopup}`}>
					<img src={listItem[winnerPopup].imgGift} alt="gift" />
				</span>
			)}
			<div className="modal-finish-foot">
				{[0, 1, 2].indexOf(winnerPopup) !== -1 && (
					<div className="modal-finish-foot-text">
						{listItem[winnerPopup].description}
					</div>
				)}
				{winnerPopup === 3 && (
					<div className="modal-finish-foot-gift">
						<div className="modal-finish-foot-gift-box">
							<div className="modal-finish-foot-gift-box-item">
								<div className="item-rank">1st prize</div>
								<img
									src={imgPrizePhone}
									alt="icon gift"
									className="img-gift-phone"
								/>
								<div className="item-info">
									<span>{rankBunpimay?.ranks?.data[0]?.full_name}</span>
									<span>{rankBunpimay?.ranks?.data[0]?.msisdn}</span>
								</div>
							</div>

							<div className="modal-finish-foot-gift-box-item">
								<div className="item-rank">2nd prize</div>
								<img src={imgPrizeHeadphone} alt="icon gift" />
								<div className="item-info">
									<span>{rankBunpimay?.ranks?.data[1]?.full_name}</span>
									<span>{rankBunpimay?.ranks?.data[1]?.msisdn}</span>
								</div>
							</div>

							<div className="modal-finish-foot-gift-box-item">
								<div className="item-rank">3rd prize</div>
								<img src={imgPrizeMoney} alt="icon gift" />
								<div className="item-info">
									<span>{rankBunpimay?.ranks?.data[2]?.full_name}</span>
									<span>{rankBunpimay?.ranks?.data[2]?.msisdn}</span>
								</div>
							</div>
						</div>
						<div className="modal-finish-foot-gift-text">
							{t('event.bunpimay.result.all')}
						</div>
					</div>
				)}

				<Button
					key="submit"
					type="primary"
					className="text-uppercase"
					onClick={handleNavigate}
				>
					{t('event.boat_racing.result.see_details')}
				</Button>
			</div>
		</div>
	</BaseModalEventBunpimay>);
}

export default ModalWinnerEventBunpimay;